import type { Prototype } from "../prototype-types";

export const katherineVidalPrototypes: Prototype[] = [
  {
    id: "fbf-performance",
    name: "FBF Performance",
    path: "/kv/fbf-performance",
    description: "",
    owner: "Katherine Vidal",
    createdAt: "2026-05-06",
    lastUpdated: "2026-05-08",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    creationTool: "claude-code",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/c8d665953022acfff2bec8cf6ad2667146a428e72b07096b25d4dde7e937e1d3.png",
  },
  {
    id: "fbf-support-messenger",
    name: "FBF Support in Messenger",
    path: "/kv/fbf-support-messenger",
    description:
      "Gives brands quick access to Faire fulfillment support directly in Messenger — pinned support thread, FBF-aware context, and quick-action chips for common issues.",
    owner: "Katherine Vidal",
    createdAt: "2026-05-04",
    lastUpdated: "2026-05-06",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/0eab6dbef14b8cd70e00cf1061c526ed9ee56618668bf588d7c59eb1d9ee06be.png",
    creationTool: "claude-code",
  },
  {
    id: "on-the-go-app",
    name: "On the Go App",
    path: "/kv/on-the-go-app",
    description:
      "iOS prototype exploring Faire's mobile retailer experience — home feed, orders, inbox, and customer creation.",
    owner: "Katherine Vidal",
    createdAt: "2026-04-22",
    lastUpdated: "2026-04-29",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "mobile",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/e1152e492b21d2296ac42cd29f271e4ac018fb33e891f8f7f48ac1a5bdb863a9.png",
    creationTool: "claude-code",
  },
  {
    id: "pack-shipment",
    name: "Pack Shipment",
    path: "/kv/pack-shipment",
    description: "Pack shipment flow for brand portal.",
    owner: "Katherine Vidal",
    createdAt: "2026-03-13",
    lastUpdated: "2026-03-18",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/a9e433e50152f5b911a253b1ad49bf358fc5843a9cc7e026c8a1e05752f0c774.png",
    creationTool: "cursor",
  },
  {
    id: "fbf-surface-test",
    name: "Fulfillment bulk editor",
    path: "/kv/fulfillment-bulk-editor",
    description:
      "Brand portal Products page with sidenav. Products section active and expanded; Fulfilled by Faire (New) below. Config-based table variants and Products view.",
    owner: "Katherine",
    createdAt: "2026-03-10",
    lastUpdated: "2026-03-17",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/ccb5bf48c92966a66486846c3c2b38f33f0ee1ff8e7ec83760860dc76b1479c1.png",
    creationTool: "cursor",
  },
  {
    id: "fulfillment-funnel",
    name: "Fulfillment Funnel",
    path: "/kv/fulfillment-funnel",
    description:
      "Interactive prototype — share this link (not Figma). Visualizing bottlenecks in the fulfillment funnel and how to fix them.",
    owner: "Katherine",
    createdAt: "2026-02-27",
    lastUpdated: "2026-03-27",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/46ec7c9a193747dd36de5073eb5eee00d9fe914747f8ec1b1ecaa27d8ab546cd.png",
    creationTool: "cursor",
  },
  {
    id: "product-setup",
    name: "Product Setup",
    path: "/kv/product-setup",
    description:
      "Product Setup prototype — brand portal Products page explorations.",
    owner: "Katherine Vidal",
    createdAt: "2026-03-13",
    lastUpdated: "2026-03-13",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/44109eb1f97fa60ef18b46c82d3018eadfc3079ea738c29faa95dd12fe4cc46b.png",
    creationTool: "cursor",
  },
  {
    id: "send-inventory-flow",
    name: "Send Inventory Flow",
    path: "/kv/send-inventory-flow",
    description:
      "FBF landing with action-first layout. Entry point for Send Inventory flow — 3 action cards (Low stock, Out of stock, Eligible products), Monthly sales impact chart, and Performance metrics.",
    owner: "Katherine Vidal",
    createdAt: "2026-03-07",
    lastUpdated: "2026-04-02",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/c8c0bdb5f67c5fbbcc39d9ade76b978454e20072972308a9a42307509a0f9628.png",
    creationTool: "claude-code",
  },
  {
    id: "catalog-dashboard-fbf",
    name: "FBF Dashboard",
    path: "/kv/faire/catalog-dashboard-fbf?variant=3",
    description:
      "Catalog Dashboard variant with Fulfilled by Faire section at top: summary cards (products in program, inventory health, avg fulfillment time), top sellers with progress bars, plus catalog score and recommendations.",
    owner: "Katherine Vidal",
    createdAt: "2026-03-06",
    lastUpdated: "2026-03-07",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/34db08ea72cd16326c122a40c9450030670456e697ade5016ff4562e04220e6d.png",
    creationTool: "cursor",
  },
  {
    id: "kv-fbf-create-shipment",
    name: "FBF Create Shipment",
    path: "/kv/fbf-create-shipment",
    description: "Inbound shipment design explorations from Design Canvas template.",
    owner: "Katherine Vidal",
    createdAt: "2026-09-24",
    lastUpdated: "2026-09-30",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/7833aed6d18861bf76d708aaa401aab972485265c9b85fb86045a967e98a297a.png",
    creationTool: "claude-code",
  }
];
